<script setup>
import { useDataFilter } from '~/core/composables/useDataFilter'

const props = defineProps({
  filter: {
    default: undefined,
  },
})

const { filter } = toRefs(props)

const { t } = useI18n()
const { label, firstSelectedOption, otherSelectedOptions, selectedOptions, value }
= useDataFilter(filter)

const isOpen = ref(false)

const valueDisplay = computed(() => {
  const firstSelectedOptionLocal
    = firstSelectedOption?.value?.label || firstSelectedOption?.value
  return !firstSelectedOptionLocal
    ? t('Select Option')
    : firstSelectedOptionLocal
    + (otherSelectedOptions?.value
      ? ` ${t('or {count} more', {
              count: otherSelectedOptions?.value,
            })}`
      : '')
})
</script>

<template>
  <DataFilterPopup
    :filter="filter"
    placement="bottom-start"
    :offset="4"
    @open="isOpen = true"
    @close="isOpen = false"
  >
    <div class="inline-flex flex-col lt-md:w-full">
      <label class="text-text-600 fw-semibold">{{
        t('Filter by {filter}', { filter: label })
      }}</label>
      <button
        class="h-40px w-full flex flex-row cursor-default items-center justify-between flex-gap-x-2 rounded bg-white px-4 py-2 text-left shadow-none ring-1 ring-surface-700 ring-inset lt-sm:text-sm"
        :class="[isOpen ? 'ring-secondary' : 'ring-surface-700']"
      >
        <span :class="{ 'text-text-300': !value }">{{ valueDisplay }}</span>
        <DSIcon
          icon="i-far-chevron-down"
          size="24"
        />
      </button>
    </div>
  </DataFilterPopup>
</template>

<i18n>
{
  "en-us": {
    "Select Option": "Select Option",
    "or {count} more": "or {count} more",
    "Filter by {filter}": "Filter by {filter}"
  }
}
</i18n>

<i18n locale="de" lang="json">
{
  "Select Option": "Option wählen",
  "or {count} more": "oder {count} mehr",
  "Filter by {filter}": "Filtern nach {filter}"
}
</i18n>

<i18n locale="fr" lang="json">
{
  "Select Option": "Sélectionner une option",
  "or {count} more": "ou {count} de plus",
  "Filter by {filter}": "Filtrer par {filter}"
}
</i18n>

<i18n locale="es" lang="json">
{
  "Select Option": "Seleccionar opción",
  "or {count} more": "o {count} más",
  "Filter by {filter}": "Filtrar por {filter}"
}
</i18n>
~/core/composables/useDataFilter
